import { VideosNoConsentCard } from 'components/video-no-consent-card';
import { SPIntlProvider } from 'contexts/intl/intlContext';

import './style.css';
import { useUserCookieConsent } from 'hooks/use-user-cookie-consent';
import { createRoot, Root } from 'react-dom/client';

function VideoTemplate({ url }: { url?: string }) {
  const { hasVideoConsent, openCookiesConsent } = useUserCookieConsent();
  if (!url || hasVideoConsent === undefined) {
    return null;
  }

  if (hasVideoConsent === false) {
    return <VideosNoConsentCard className="tutorial-video mb-4 px-4" openCookiesConsent={openCookiesConsent} />;
  }

  return (
    <div className="tutorial-video bg-light mb-4">
      <iframe id="video-player" className="h-100 w-100" src={url} allowFullScreen allow="fullscreen" />
    </div>
  );
}

class TutorialVideo extends HTMLElement {
  private root: Root | null = null;
  private url = '';

  static get observedAttributes() {
    return ['url'];
  }

  constructor() {
    super();
  }

  connectedCallback() {
    this.root = createRoot(this);
    this.renderReact();
  }

  disconnectedCallback() {
    this.root?.unmount();
    this.root = null;
  }

  attributeChangedCallback(name: string, _oldValue: string | null, newValue: string | null) {
    if (name === 'url') {
      this.url = newValue ?? '';
      this.renderReact();
    }
  }

  private renderReact() {
    if (this.root) {
      this.root.render(
        <SPIntlProvider locale="en">
          <VideoTemplate url={this.url} />
        </SPIntlProvider>,
      );
    }
  }
}

export const tutorialVideoTagName = 'tutorial-video';
window.customElements.define(tutorialVideoTagName, TutorialVideo);
